
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<input id=\"{{ id }}\" type=\"checkbox\" class=\"show-password\" aria-controls=\"{{ targetId }}\" tabindex=\"-1\" data-novalue data-synchronize-show=\"{{ synchronizeShow }}\"/>\n<label for=\"{{ id }}\" class=\"show-password-label\">\n  {{#t}}Show{{/t}}\n</label>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/partial/show-password.mustache
// module id = 216
// module chunks = app